import { Account, Balance } from '~/types';

export const getCurrentBalance = (account: Account): Balance | undefined => {
  const CURRENT_AVAILABLE = account.balances?.find(
    (balanceItem) => balanceItem.balanceType === 'CURRENT_AVAILABLE'
  );
  const CURRENT_FLOAT = account.balances?.find(
    (balanceItem) => balanceItem.balanceType === 'CURRENT_FLOAT'
  );

  return CURRENT_AVAILABLE || CURRENT_FLOAT;
};
